import React, { useState, useEffect } from "react";
import { fetchSimilarProducts } from "services/api/rebuy";
import ProductItem from "components/product/item";
import { mapRebuyProduct } from "helpers/rebuy";
import SkeletonCards from "components/loader/skeleton-cards";
import clsx from "clsx/lite";

const SimilarProducts = ({ data, productId, className }) => {
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchData = async () => {
		try {
			// Fetch similar products
			const similarProducts = await fetchSimilarProducts(productId);
			setProducts(similarProducts);
		} catch (error) {
			console.error("Error fetching similar products:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	if (!products.length && !loading) return null;

	return (
		<div className={clsx("standard-section-width mx-auto", className)}>
			{loading ? (
				<SkeletonCards numOfRows={1} itemsPerRow={4} />
			) : (
				<>
					{data.title && <h3 className="pb-5 horizontal-padding">{data.title}</h3>}
					<div className="overflow-hidden">
						<div className="flex overflow-auto gap-x-6 no-scrollbar horizontal-padding xl:grid xl:grid-cols-4">
							{products.map((product) => (
								<ProductItem
									className="min-w-72"
									key={product.id}
									showModal={false}
									product={mapRebuyProduct(product)}
									source="pdp_similar_products"
								/>
							))}
						</div>
					</div>
				</>
			)}
		</div>
	);

};

export default SimilarProducts;
